var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root lx-modal-new"},[_c('lx-icon-button',{staticClass:"close-btn",attrs:{"ariaLabel":"Close modal","icon":"close","size":"16","disabled":_vm.closeDisabled},on:{"click":_vm.close}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }